import { Radio } from "antd";
import styled from "styled-components";

export const TARadio = styled(Radio)``;
